import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Device } from 'modules/Device/Device'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class CalibrationOrg extends Model {
  static override entity = 'calibration_orgs'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare calibrator_number: number
  @Attr(null) declare name: string | null
  @Attr(null) declare address: string | null
  @Attr(null) declare phone: string | null
  @Attr(null) declare main_contact: string | null

  @HasMany(() => Device, 'calibration_org_id') declare devices: Device[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
